import { GlobalState, UI } from '@leverege/ui-redux'

export const getInitAttributes = ( molten, appId ) => {
  return {
    app_id : appId,
    custom_launcher_selector : '#customer-support',
    alignment : 'right',
    Type : 'Dealer',
    hide_default_launcher : true
  }
}

export const getLoginAttributes = async ( molten, loginAction ) => {
  const { profile } = loginAction
  const state = GlobalState.get()
  const { thunkArgs : { api } } = molten
  const systemId = api.options.systemId

  const activePersona = UI.get( state ).activePersona

  const res = await api
    .interface( systemId, 'location' )
    .list()

  return {
    name : profile.name,
    email : profile.username,
    Second_Email : profile.email,
    phone : profile.phone,
    Role : activePersona?.name,
    companies : res.items.map( item => ( {
      company_id : item?.id,
      name : item?.data?.name,
      Dealership_LocationName : item?.data?.name,
      Dealership_Location_KudelskiID : item?.data?.intercom?.Dealership_Location_KudelskiID
    } ) )
  }
}
